import { LearningChatHome } from "./LearningChatHome.js";
import { LearningChatSession } from "./LearningChatSession.js";
import { useLearningChatPage } from "./use-learning-chat-page.js";

export function LearningChatPage() {
  const chat = useLearningChatPage();

  if (!chat.active) {
    return (
      <LearningChatHome
        draft={chat.draft}
        formatDate={chat.formatDate}
        history={chat.history}
        onDraftChange={chat.setDraft}
        onOpenHistory={chat.openHistory}
        onOpenSituation={chat.openSituation}
        onPrefillDemo={chat.prefillDemo}
        onSend={chat.sendDraft}
      />
    );
  }

  return (
    <LearningChatSession
      bottomRef={chat.bottomRef}
      draft={chat.draft}
      onAnswer={chat.sendThreadMessage}
      onBack={chat.goHome}
      onDraftChange={chat.setDraft}
      session={chat.active}
    />
  );
}
